import baseUrl from './url'
import ApiRequest from './config'

const API = {}

API.omdbMovies = ApiRequest.get(baseUrl.movieList);

export * from './config';

export default API;
